import { DirectiveBinding, ObjectDirective } from "vue"

interface AddClassOnHoverElement extends HTMLElement {
  _mouseenterHandler?: () => void;
  _mouseleaveHandler?: () => void;
}

const addClassOnHoverDirective: ObjectDirective = {
  mounted (el: AddClassOnHoverElement, binding: DirectiveBinding): void {
    const { value = "hover" } = binding

    const mouseenterHandler = (): void => {
      el.classList.add(value)
    }

    const mouseleaveHandler = (): void => {
      el.classList.remove(value)
    }

    el._mouseenterHandler = mouseenterHandler
    el._mouseleaveHandler = mouseleaveHandler

    el.addEventListener("mouseenter", mouseenterHandler)
    el.addEventListener("mouseleave", mouseleaveHandler)
  },

  unmounted (el: AddClassOnHoverElement): void {
    if (el._mouseenterHandler) {
      el.removeEventListener("mouseenter", el._mouseenterHandler)
    }

    if (el._mouseleaveHandler) {
      el.removeEventListener("mouseleave", el._mouseleaveHandler)
    }
  }
}

export default addClassOnHoverDirective
